import { SolText } from '@sol/components';
import { Scope, Subscope } from '../services/session.service';

export class ScopeTools {
  private constructor() {}

  public static scopeToName(scope?: Scope): string {
    return scope?.displayName ?? scope?.name ?? '';
  }

  /**
   * Label a record's subscope: the API-resolved name first, otherwise the session subscope whose
   * key or id matches the stored identifier — v1-created records store the Postgres id where a
   * Mongo key belongs, and a 24-hex key never collides with an integer id.
   */
  public static subscopeToText(
    storedSubscope: string | undefined,
    resolvedName: string | undefined,
    subscopes: readonly Subscope[],
  ): SolText {
    if (!storedSubscope) {
      return SolText.of('asm-components.scope.global');
    }
    if (resolvedName) {
      return SolText.ofRaw(resolvedName);
    }
    const matched = subscopes.find(subscope => subscope.key === storedSubscope || subscope.id === storedSubscope);
    return matched ? SolText.ofRaw(matched.displayName) : SolText.of('asm-components.scope.subscope-unknown');
  }
}
